module.exports = __webpack_public_path__ + "static/media/ptu_logo.a511b92a.png";